module.exports = "<aside class=\"aside-menu\">\n  \n</aside>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-aside/app-aside.component.html
// module id = ../../../../../src/app/components/app-aside/app-aside.component.html
// module chunks = main